import React from 'react';
import { Row, Col } from "react-bootstrap";
import PropTypes from 'prop-types';
import { Button, SvgIcon } from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import CheckCircleWhite from '../../../../../icons/check-circle-white.svg?react';
import './StyledRadio.scss';

function FancyButton(props) {

    const buttonClasses = `style-radio-button ${(props.active ? 'styledButtonActive' : 'styled-radio-button-inactive')} ${(props.error ? 'styled-button-error' : '')} ${props.isWhiteBackground ? 'white-background' : ''}`;

    const blankIcon = props.isBlankIcon ? <SvgIcon component={CheckCircleWhite} /> : <CheckCircleIcon htmlColor='#bbb' />;

    return (
        <Button id="radio-input" className={buttonClasses} variant="outlined" color="primary" fullWidth onClick={props.onClick} aria-describedby="radio-input" aria-invalid="true">
            {props.icon && <div className='me-2'>{props.icon}</div>}
            <div> {props.active ? <CheckCircleIcon color="primary" /> : blankIcon} </div>
            <div className='styled-radio-label'>{props.label}</div>
        </Button>
    )
}

export default function StyledRadioInput(props) {

    return (
        <div>
            {props.label && <legend className='radio-label'>{props.label}</legend>}
            <Row className='radio-input sm-gutter'>
                {props.options.map((data, i) => {
                    return (
                        <Col xs={6} key={i}>
                            <div className='form-group mb-3'>
                                <FancyButton
                                    active={props.value === data.value}
                                    icon={data.icon}
                                    label={data.label}
                                    onClick={() => props.onChange(data.value)}
                                    error={!!props.errors}
                                    isBlankIcon={props.isBlankIcon}
                                    isWhiteBackground={props.isWhiteBackground}
                                />
                            </div>
                        </Col>
                    )
                })}

                {props.errors && <span className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error d-block px-0">{props.errors.message}</span>}
            </Row>
        </div>
    )
}

StyledRadioInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.object,
    value: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        icon: PropTypes.object,
    })),
}
